import { useStyletron } from 'baseui';
import { Col, Row } from 'react-bootstrap';
import React from 'react';

const SectionTitle: React.FC<{ title: string }> = ({ title }) => {
  const [css] = useStyletron();

  return (
    <Row className="justify-content-center">
      <Col xs={12}>
        <h4 className={`${css({ marginTop: '-24px' })} mb-4`}>{title}</h4>
      </Col>
    </Row>
  );
};

export default SectionTitle;
